;(function (angular) {
  'use strict'

  angular
    .module('kilo.routes.entity.list', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = [ '$stateProvider' ]

  function RouteConfigurator ($stateProvider) {
    var showState = {
      name: 'entity.list',
      url: '/list',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) { pagination.destroy() }],
      title: 'ANNUAIRE',
      resolve: {
        pagination: [ 'PaginationModel', function (PaginationModel) {
          return PaginationModel.get('entityList')
        } ],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(CustomFieldManager.query().select('Entity', 'model'))
            .then(function (data) {
              return data.data
            })
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/entity/list/templates/entity-list.template.html',
          controller: 'EntityListController',
          controllerAs: 'list'
        },
        'toolbar@': {
          templateUrl: '/app/modules/entity/list/templates/entity-list-toolbar.html',
          controller: 'EntityListToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Annuaire'
      }
    }
    $stateProvider
      .state(showState)
  }
})(window.angular)
